import React from 'react';
import { Header, Table, Input } from 'semantic-ui-react';
import styled from 'styled-components';
import HeadMealTable from './HeadMealTable';
import DishRow from './DishRow';
import MenuTotalCBGU from './MenuTotalCBGU';

const MealTable = React.memo(
  ({
    title = '',
    meals = [],
    type,
    changeDishPortion,
    changeDish,
    addDish,
    dayIndex,
    deleteDish,
    time,
    changeMealTime,
    changeDishTime,
    isRedHead,
  }) => {
    const countTotalFitValues = (valueName) => {
      let totalFitValue = 0;
      meals.forEach((dishData) => {
        totalFitValue += dishData[`counted_${valueName}`];
      });
      return totalFitValue.toFixed(2);
    };
    return (
      <div>
        <WrapMealTableHeader>
          <Header as="h2" textAlign="center" className="mealTableHeaderTitle">
            {title}
          </Header>
          {time !== null ? (
            <Input
              value={time}
              onChange={(e, data) => changeMealTime(dayIndex, type, data.value)}
              placeholder="Время приема"
              style={{ width: 150, fontSize: 17 }}
            />
          ) : (
            <div style={{ width: 150 }} />
          )}
        </WrapMealTableHeader>
        <Table celled>
          <HeadMealTable addDish={() => addDish(dayIndex, type)} isRedHead={isRedHead} />
          <Table.Body>
            {meals.map((dishData) => {
              return (
                <DishRow
                  key={dishData.id}
                  dishId={dishData.id}
                  dishData={dishData.dish}
                  recipe={dishData.dish && dishData.dish.recepie}
                  calories={dishData ? dishData.counted_calories : 0}
                  carbohydrates={dishData ? dishData.counted_carbohydrates : 0}
                  fats={dishData ? dishData.counted_fats : 0}
                  proteins={dishData ? dishData.counted_proteins : 0}
                  quantity={dishData ? dishData.quantity : 0}
                  time={dishData.dish && dishData.dish.name === 'Вода' ? dishData.time : null}
                  changeDishPortion={changeDishPortion}
                  changeDish={changeDish}
                  deleteDish={deleteDish}
                  changeDishTime={changeDishTime}
                  type={type}
                />
              );
            })}
          </Table.Body>
        </Table>
        {!!meals.length && (
          <MenuTotalCBGU
            title="Всего за прием:"
            totalCalories={countTotalFitValues('calories')}
            totalProteins={countTotalFitValues('proteins')}
            totalFats={countTotalFitValues('fats')}
            totalCarbohydrates={countTotalFitValues('carbohydrates')}
          />
        )}
      </div>
    );
  },
);

export default MealTable;

const WrapMealTableHeader = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:before {
    content: '';
    display: inline-flex;
    width: 150px;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Common/MenuBlock/MealTable.jsx